export interface IMaterial {
    value: string;
    label: string;
    color?: string;
    children?: IMaterial[];
}

export const Materials: IMaterial[] = [
    {
      value: 'ferrous',
      label: $localize`Ferrous`,
      color: '#424242',
      children: [
        {
            value: 'cast-iron',
            label: $localize`Cast iron`
        },
        {
            value: 'carbon-or-mild-steel',
            label: $localize`Carbon or mild steel`
        },
        {
            value: 'low-alloy-steel',
            label: $localize`Low-alloy steel`
        },
        {
            value: 'alloy-or-special-steel',
            label: $localize`Alloy steel or special steel`
        },
        {
            value: 'stainless-steel',
            label: $localize`Stainless steel`
        }
      ]
    },
    {
      value: 'not-ferrous',
      label: $localize`Non-Ferrous`,
      color: '#616161',
      children: [
        {
            value: 'lead',
            label: $localize`Lead`
        },
        {
            value: 'nickel',
            label: $localize`Nickel`
        },
        {
            value: 'tin',
            label: $localize`Tin`
        },
        {
            value: 'chromium',
            label: $localize`Chrome`
        },
        {
            value: 'zinc',
            label: $localize`Zinc`
        },
        {
            value: 'silver',
            label: $localize`Silver`
        },
        {
            value: 'brass',
            label: $localize`Brass`
        },
        {
            value: 'titanium',
            label: $localize`Titanium`
        },
        {
            value: 'magnesium',
            label: $localize`Magnesium`
        },
        {
            value: 'copper-and-copper-alloys',
            label: $localize`Copper and copper alloys`
        },
        {
            value: 'aluminium-and-aluminium-alloys',
            label: $localize`Aluminum and aluminum alloys`
        }
      ]
    },
    {
      value: 'other-materials',
      label: $localize`Other materials`,
      color: '#9E9E9E',
      children: [
        {
          value: 'other-materials',
          label: $localize`Other materials`
        }
      ]
    }
];


